import Vue from "vue";
import Vuex from "vuex";
import search from "./modules/search";
import pricelist from "./modules/pricelist";
import version from "./modules/version";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    search,
    pricelist,
    version
  },
  strict: true //debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js